import React, { FunctionComponent} from 'react'

const HeaderLogo: FunctionComponent = () => {
    const headerLogoSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 127.84 127.84" style="enable-background:new 0 0 127.84 127.84;" xml:space="preserve">
<style type="text/css">
    .st0{fill:url(#SVGID_1_);}
    .st1{fill:#FFFFFF;}
    .st2{fill:#CF2437;}
    .st3{fill:#414141;}
</style>
    <g>
    <g>
        <g>
            <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="18.8219" y1="109.0207" x2="109.0207" y2="18.8219">
                <stop offset="0" style="stop-color:#EC008C"/>
                <stop offset="0.4832" style="stop-color:#F7941D"/>
                <stop offset="0.9888" style="stop-color:#EC008C"/>
            </linearGradient>
            <ellipse class="st0" cx="63.92" cy="63.92" rx="63.78" ry="63.78"/>
            <circle class="st1" cx="63.92" cy="63.92" r="44.4"/>
            <g>
                <path class="st2" d="M63.92,108.32c-11.19,0-21.88-4.18-30.11-11.78l3.42-3.7c7.29,6.73,16.77,10.44,26.69,10.44      c21.7,0,39.36-17.66,39.36-39.36S85.63,24.56,63.92,24.56v-5.04c24.48,0,44.4,19.92,44.4,44.4S88.4,108.32,63.92,108.32z"/>
            </g>
        </g>
    </g>
        <g>
        <g>
            <g>
                <path class="st3" d="M52.9,60.26l-3.5-2.85l1.43-1.75c1.13-1.38,0.8-2.41-0.34-4.78c-0.99-2.05-2.64-5.47,0.58-8.39l1.67-1.52      l3.03,3.35l-1.67,1.52c-0.55,0.5-0.71,0.65,0.46,3.08c1.13,2.33,2.82,5.86-0.22,9.6L52.9,60.26z"/>
            </g>
            <g>
                <path class="st3" d="M73.54,60.26l-3.5-2.85l1.43-1.75c1.13-1.38,0.8-2.41-0.34-4.78c-0.99-2.05-2.64-5.47,0.58-8.39l1.67-1.52      l3.03,3.35l-1.67,1.52c-0.55,0.5-0.71,0.65,0.46,3.08c1.13,2.33,2.82,5.86-0.22,9.6L73.54,60.26z"/>
            </g>
        </g>
            <g>
            <path class="st3" d="M37.19,65.07c2.06,12.36,12.79,21.78,25.73,21.78s23.68-9.42,25.73-21.78H37.19z"/>
        </g>
    </g>
</g>
</svg>
    `

    return <span dangerouslySetInnerHTML={{__html: headerLogoSVG}} />
}

export default HeaderLogo